<template>
  <div class="bodyTable">
    <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="rigaCodice"
      :headers="headers"
      :items="righeLotto"
      :options.sync="options"
      :server-items-length="totaleRighe"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      dense
      calculate-widths
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand      
    > 
      <template v-slot:[`item.rigaDescrittiva`]="{ item, index }">
        <component :is="'pSwitch'" :item="itemRigaDescrittiva(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="disableRigaDescrittiva(item)" :updateTrigger="updateTrigger"/>
      </template>    
      <template v-slot:[`item.codice`]="{ item, index }">
        <component :is="'pProdotto'"  v-if="!item.rigaDescrittiva" :item="itemCodice(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true" :isLotto="true" :isProdottoBase="true"/>
      </template>       
      <template v-slot:[`item.descrizione`]="{ item, index }">
        {{ (item.rigaIndentata ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '') }}<component :is="'pTesto'" :item="itemDescrizione(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template>
      <template v-slot:[`item.quantita`]="{ item, index }">
        <component :is="'pTesto'" :item="itemQuantita(item)" :ref="`quantita_${index}`" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template>
      <template v-slot:[`item.usaQuantitaTeorica`]="{ item, index }">
        <component :is="'pSwitch'" :item="itemUsaTeorica(item)" v-if="!item.rigaDescrittiva" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :updateTrigger="updateTrigger"/>
      </template>
      <template v-slot:[`item.custom.riferimento`]="{ item,index }">
        <component :is="'pTesto'" :item="itemLottoRiferimento(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template>

      <template v-slot:[`item.actions`]="{ item, index }">
        <v-icon small class="mr-2" @click="dettaglioLottoItem(item, index)" title="Dettaglio lotto">mdi-clipboard-text-outline</v-icon>
        <v-icon small @click="deleteItem(item)" title="Cancella la riga">mdi-delete</v-icon>
        <v-menu :offset-x="true" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-2" v-bind="attrs" v-on="on" title="Azioni aggiuntive">mdi-dots-vertical</v-icon>
          </template>
          <three-dots-menu :item="item" :index="index" :rowsNumber="righeLotto.length" @click="menuClick"/>
        </v-menu>    
<!--         <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
          </template>
          <span>Cancella la riga</span>
        </v-tooltip>        --> 
<!--         <v-dialog v-model="dialog" max-width="500px" v-if="!item.rigaDescrittiva" :retain-focus="false">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-3 mr-0" v-bind="attrs" v-on="on" title="Modifica prezzi e sconti">mdi-calculator</v-icon>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">Sconti e importi</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <component :is="'pQuattroValori'" :item="itemPrezzi(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :lockValori="aggiornaSconti ? 1 : 2" @toggleLock="toggleLock"/>
                  </v-col>
                  <v-col cols="12">
                    <component :is="'pQuattroValori'" :item="itemSconti(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :lockValori="!aggiornaSconti ? 1 : 2" @toggleLock="toggleLock"/>
                  </v-col>
                  <v-col cols="12">
                    <component :is="'pQuattroValori'" :item="itemImporti(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click.stop="dialogClose">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </template>
      <template v-slot:[`foot`]>
        <v-btn class="text-right" @click="onNuovaRiga" v-if="nuovaRigaAbilitata">Nuova riga</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="dettaglioLottoSelected">
          <v-tabs dense v-model="tab[item.rigaCodice]">
            <v-tab key="dichiarazioneAssemblaggio" class="dettaglioLottoSelected">Dichiarazione assemblaggio</v-tab>
            <!-- <v-tab key="distintaBase" class="dettaglioLottoSelected">Distinta base</v-tab> -->
          </v-tabs>
          <v-tabs-items v-model="tab[item.rigaCodice]">
            <v-tab-item key="dichiarazioneAssemblaggio">
              <dettaglio-assemblaggio :item="item" :headers="headers" :usaQuantitaTeorica="item.usaQuantitaTeorica" :updateTrigger="updateTrigger" @distinta="onChangeDistinta(item, $event)"/>
            </v-tab-item>
<!--             <v-tab-item key="distintaBase">
            </v-tab-item> -->
          </v-tabs-items>
          
        </td>
        <!-- <td :colspan="headers.length" class="articoliSelected"> -->
      </template>   
<!--       <template v-slot:[`footer.prepend`]>
        <v-btn color="success" @click="onMostraParcheggio" v-if="nuovaRigaAbilitata">Importa da Park</v-btn>
      </template> -->
    </v-data-table>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
        <v-card-text>{{dettaglioRiga}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-storico :show="dialogStorico" :prodotto="prodottoStorico"/>
    <dialog-lotto :show="dialogLotto" :prodotto="prodottoLotto" @save="salvaDettaglioLotto"/>
  </div>
</template>

<script>
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import { v4 as uuidv4 } from 'uuid'
  import prodotti from '@/services/prodottiService.js'
  import pProdotto from '../../elementi/prodotto'
  import pSwitch from '../../elementi/switch'
  import pTesto from '../../elementi/testo'
  import pData from '../../elementi/data'
  import pMultiselect from '../../elementi/multiselect'
  import ThreeDotsMenu from '../../elementiBody/threeDotsMenu'
  import DialogStorico from '../../elementiBody/dialogStorico'
  import DialogLotto from './dialogLotto'
  import DettaglioAssemblaggio from './bodyAssemblaggio'

  export default {
    components: {
      pProdotto,
      pSwitch,
      pTesto,
/*       pData,
      pMultiselect, */
      ThreeDotsMenu,
      DialogStorico,
      DialogLotto,
      DettaglioAssemblaggio
      // pQuattroValori
    },
    props: {
      locLotto: Object,
      trigger: { type: Number, default: 1}
    },
    data () {
      return {
        selected: [],
        loading: false,
        options: {},
        headers: [
          { text: 'Descrittiva', value:'rigaDescrittiva', width: 30 }, 
          { text: 'Codice', value: 'codice', align: 'start', width: '10%'},
          { text: 'Descrizione', value: 'descrizione', width: '25%' },
          { text: 'Quantità', value: 'quantita', align: 'start', width: '8%' },
          { text: 'Usa Teorica', value: 'usaQuantitaTeorica', align: 'start', width: '7%' },
          { text: 'Riferimento', value: 'custom.riferimento', align: 'start'},
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialog: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
/*         defaultItem: null,
        modelloLotto: null, */
        filtri: null,
        tab: {},
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreLotto: '',
        updateTrigger: 1,
        readOnly: false, // eventualmente su computed,
        locRigaLotto: null,
        rigaModello: {
          rigaDescrittiva: false,
          codice: '',
          descrizione: '',
          quantita: ''
        },
        aggiornaSconti: true, // da impostazioni scelgo se aggiornare gli sconti o il prezzo di listino nel caso di modifica dell'importo
        dialogStorico: false,
        prodottoStorico: null,
        mostraParcheggio: false,
        dialogLotto: false,
        prodottoLotto: null
      }
    },
    computed: {
      righeLotto() {
        return _.get(this, 'locLotto.righe', [])
      },
      totaleRighe() {
        return this.righeLotto.length
      },
      nuovaRigaAbilitata() {
        return this.trigger && this.locLotto.magazzino
      },
      dettaglioRiga() {
        let riga = this.editedIndex
        if (riga === -1) return
        let ed = this.righeLotto[riga]
        if (!ed) return ''
        return ed.descrizione.trim()
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      dialog (val) {
        val || this.dialogClose()
      },     
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },
    async mounted () {
      this.$root.$on('aggiungiProdotti', this.onAggiungiProdotti)
    },
    methods: {
      onChangeDistinta(item, value) {
        item.distinta = value
      },
      salvaDettaglioLotto(custom) {
        this.locLotto.custom = custom
        this.updateTrigger++
      },
      async dettaglioLottoItem(item, index) {
        item.custom = item.custom || {}
        item.custom.carne = item.custom.carne || {}
        this.prodottoLotto = item // this.locLotto.righe[index]
        this.dialogLotto = true
        await this.$nextTick()
        this.dialogLotto = false
      },
      async onAggiungiProdotti(righe) {
        for (let riga of righe) {
          const idProdotto = riga.codice
          const p = await prodotti.getProdotto(idProdotto)
          let nr = JSON.parse(JSON.stringify(this.rigaModello))
          nr.valore = nr.valore || {}
          nr.valore.listino = this.locLotto.appoggio.clifor.amministrativi.listino
          nr.valore = { ...nr.valore, ...this.locLotto.appoggio.clifor.amministrativi.sconti }
          _.set(nr, 'appoggio.prodotto', p)
          _.set(nr, 'prodotto.codice', idProdotto)
          this.$emit('nuovaRiga', nr) // verificare se a questo livello o alla fine, dopo aver aggiunto il prodotto
          await this.$nextTick()
          const index = this.locLotto.righe.length - 1
          let data = {
            model: 'prodotto.codice',
            subModel: null,
            value: p._id,
            item: p,
            index: index
          }
          await this.componentValueChange(data)
          data = {
            model: 'quantita',
            decimals: 2,
            subModel: null,
            value: riga.quantita,
            item: null,
            index: index
          }
          await this.componentValueChange(data)
        }
        await this.$nextTick()
        this.mostraParcheggio = false
        this.$emit('mostraParcheggio', false)
      },
      async menuClick({ command, index }) {
        switch(command) {
          case 'utility_storico':
            this.dialogStorico = true
            this.prodottoStorico = this.locLotto.righe[index]
            await this.$nextTick()
            this.dialogStorico = false
            break
          case 'move_top':
            this.$emit('move', index, 0)
            break
          case 'move_bottom':
            this.$emit('move', index, -1)
            break
          case 'move_up':
            this.$emit('move', index, index - 1)
            break
          case 'move_down':
            this.$emit('move', index, index + 1)
            break
          default:
            break
        }
      },
      disableRigaDescrittiva(item) {
        const isProdotto = item.prodotto && item.prodotto.codice.length > 0 ? true : false
        const isQuantita = item.quantita && parseFloat(item.quantita) > 0 ? true : false
        return this.readOnly || isProdotto || isQuantita
      },      
      toggleLock() {
        this.aggiornaSconti = !this.aggiornaSconti
      },
      dialogClose () {
        this.dialog = false
        this.$nextTick(() => {
/*           this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1 */
        })
      },
      itemRigaDescrittiva(item) {
        return  {
          "model": "rigaDescrittiva",
          "valueField": "rigaDescrittiva",
          "type": "Switch",
          "label": "",
          value: _.get(item, 'rigaDescrittiva', false)
        }
      },
      itemUsaTeorica(item) {
        return  {
          "model": "usaQuantitaTeorica",
          "valueField": "usaQuantitaTeorica",
          "type": "Switch",
          "label": "",
          value: _.get(item, 'usaQuantitaTeorica', true)
        }
      },
      itemCodice(item) {
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          "cercaEsterno": true,
          value: _.get(item, 'prodotto.codice', '')          
        }
      },
      itemDescrizione(item) {
        return {
          "model": "descrizione",
          "valueField": "descrizione",
          "label": "Descrizione",
          "type": "TextArea",
          "required": true,
          value: _.get(item, 'descrizione', '') 
        }
      },
      itemQuantita(item) {
        return {
          "model": "quantita",
          "valueField": "quantita",
          "label": "Quantità",
          "type": "Testo",
          "required": false,
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'quantita', '') 
        }
      },
      itemLottoRiferimento(item) {
        return {
          "model": "custom.riferimento",
          "valueField": "custom.riferimento",
          "label": "Riferimento",
          "type": "Testo",
          "required": false,
          value: item.custom ? item.custom.riferimento : '' // _.get(item, 'lotto.riferimento', '')
        }
      },  
      itemUnitaMisura(item) {
        return {
          "model": "unitaMisura",
          "valueField": "unitaMisura",
          "type": "Multiselect",
          "label": "UM",
          "source": "prodotti_unita_misura.um",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'unitaMisura', '') 
        }
      },
      async onNuovaRiga() {
        const nr = JSON.parse(JSON.stringify(this.rigaModello))
        nr.appoggio = nr.appoggio || {}
        nr.rigaCodice = uuidv4()
        this.$emit('nuovaRiga', nr)
      },
      async editItem (item) {
      },
      duplicateItem(item) {
      },
      deleteItem (item) {
        this.editedIndex = this.righeLotto.indexOf(item)
        this.dialogDelete = true
/*         this.editedIndex = this.righeLotto.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true */
      },
      async deleteItemConfirm () {
        this.righeLotto.splice(this.editedIndex, 1)
        // Verificare in base al tipo lotto se va aggiornata la giacenza
        // Nel caso fare un movimento di rettifica
/*         if (this.locLotto._id) {
          await prodotti.aggiornaDeltaGiacenza(
            this.editedItem.items.prodotto._id,
            this.editedItem.items.lotto.magazzino,
            -this.editedItem.items.lotto.quantita
          )
        } */
        this.closeDelete()
        this.editedIndex = -1
        this.$emit('updateTotali')
      },

      close () {
        this.dialog = false
/*         this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        }) */
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          // this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      async save () {
/*         this.$store.commit('lottiDettaglio/CLEAR_RIGA_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['lottiDettaglio/rigaLotto']
        let lotto = await lotti.getLotto(this.chiaveLotto._id)
        if (this.editedIndex > -1) {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          Object.assign(this.righeLotto[this.editedIndex], this.editedItem)
          Object.assign(lotto.righe[this.editedIndex], this.editedItem)
        } else {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          this.righeLotto.push(this.editedItem)
          lotto.righe = lotto.righe || []
          lotto.righe.push(this.editedItem)
        }
        if (!await lotti.aggiornaLotto(lotto)) {
          this.dialogErrore = true
          return
        }
        this.close()
        this.$store.commit('lottiDettaglio/CLEAR_RIGA_DOCUMENTO')
        await this.getDataFromApi() */
      },      
      erroreConfirm() {
        this.dialogErrore = false
        this.erroreLotto = ''
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        this.locRigaLotto = this.righeLotto[index]
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.locRigaLotto, tgt)
        await this.aggiornaCorrelati(data)
        // this.$store.commit('lottiDettaglio/SET_RIGA_DOCUMENTO', this.locRigaLotto) // verificare se va fatta store_temp
      },
      async aggiornaCorrelati(data) {
        this.locRigaLotto.appoggio = this.locRigaLotto.appoggio || {}
        let tipoModifica = ''
        switch (data.model) {
          case 'prodotto.codice':
            if (!data.value) {
              delete this.locRigaLotto.appoggio.prodotto
              delete this.locRigaLotto.prodotto
              _.set(this.locRigaLotto, 'valore.prezzoUnitario', 0)   
              this.locRigaLotto.descrizione = ''
            } else {
              this.locRigaLotto.appoggio.prodotto = data.item
              this.locRigaLotto.descrizione = (`${data.item.descrizione} ${_.get(data.item, 'variante2.descrizione', '')} ${_.get(data.item, 'variante1.descrizione', '')}`).trim()
              if (this.locRigaLotto.appoggio.importiModificati) { // La prima volta, devo rileggere il prodotto ma non impostare il listino. Se cambio prodotto, si
                this.locRigaLotto.appoggio.importiModificati = false
                this.updateTrigger++
                return
              }
              this.locRigaLotto.tipoBene = data.item.tipoBene || data.item.item.tipoBene
              this.locRigaLotto.repartoFiscale = data.item.datiFiscali.reparto.stampante
              this.locRigaLotto.unitaMisura = _.get(data.item, 'magazzino.unitaMisura', _.get(data.item, 'item.magazzino.unitaMisura', ''))
              this.locRigaLotto.aliquotaIva = data.item.datiFiscali.aliquoteIva[0]
              this.locRigaLotto.base = data.value
              await this.$nextTick()
              const ref = this.$refs[`quantita_${data.index}`]
              const input = ref.$el.querySelector('input:not([type=hidden]),textarea:not([type=hidden])')
              if (input) {
                setTimeout(() => {
                  input.focus()
                }, 0)
              }
            }
            break;
          case 'rigaDescrittiva':
            delete this.locRigaLotto.appoggio.prodotto
            delete this.locRigaLotto.prodotto
            _.set(this.locRigaLotto, 'valore.prezzoUnitario', 0)
            _.set(this.locRigaLotto, 'appoggio.rigaDescrittiva', data.value)       
            this.locRigaLotto.descrizione = ''
            break;
          case 'quantita':    
            break;
          default:
            break
        }
        this.updateTrigger++
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.dettaglioLottoSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }

  .bodyTable .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0;
  }
</style>

<style scoped>
/*   .v-input, .v-label {
    font-size: 0.7em;
  } */
</style>